import { ModalBody, Box, Link } from "@chakra-ui/react";
import keywordSearchImg from "./updateImgs/keyword_search.png";
import forwardBackwardImg from "./updateImgs/forward_backward_chapter.gif";
import lineByLineImg from "./updateImgs/line_by_line.png";
import searchHistoryImg from "./updateImgs/search_history.png";
import textSizeLineHeightImg from "./updateImgs/text_size_line_height.gif";
import autoCompleteBookNameImg from "./updateImgs/auto_complete_book_name.gif";
import englishBookNameImg from "./updateImgs/english_book_name.png";
import dropDownMenuImg from "./updateImgs/dropdown_menu.png";
import esvImg from "./updateImgs/esv.png";

interface CustomImageProps {
  src: string;
  alt: string;
}

const CustomImage = ({ src, alt }: CustomImageProps) => (
  <Box
    as="img"
    src={src}
    alt={alt}
    borderRadius="15px" // Adjust the value for desired roundness
    boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)" // Optional shadow for better aesthetics
    width="100%" // Responsive width
    maxWidth="400px" // Limit the max width
    objectFit="cover" // Ensures image fits nicely
    mt={4} // Optional margin top for spacing
  />
);

export const WhatsNew: React.FC = (): JSX.Element => {
  return (
    <ModalBody p={0} h="100%" mt="-5px">
      <Box
        overflowY="scroll"
        p={4} // Optional padding for better text readability
        maxH="380px" // Adjust this to limit the max height if needed
      >
        {/* 03/14/2026 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>03/14/2026</h3>
          <br />
          <b>UI Update</b>
          <br />
          Verse display area now expands to fill the screen with a consistent bottom margin.
          <br />
          <br />
          <b>Smarter Tips</b>
          <br />
          Contextual suggestions now appear automatically — e.g. when searching Chinese with ESV selected.
          <br />
          <br />
        </p>

        {/* 06/03/2025 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>06/03/2025</h3>
          <br />
          <b>Add ESV</b>
          <br />
          <>
            The{" "}
            <Link href="https://www.esv.org/" isExternal color="blue.500">
              English Standard Version (ESV)
            </Link>{" "}
            is a translation of the Bible in contemporary English.
          </>
          <br />
          <CustomImage src={esvImg} alt="ESV" />
          <br />
        </p>

        {/* 06/20/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>06/20/2024</h3>
          <br />
          <b>What's New</b>
          <br />
          Added a "What's New" section to the settings modal for users to see the latest updates.
          <br />
          <br />
        </p>

        {/* 06/19/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>06/19/2024</h3>
          <br />
          <b>Keywords Search </b>
          <br />
          <CustomImage src={keywordSearchImg} alt="Keywords Search" />
          <br />
          Users can now search for Bible verses using keywords. Multiple keywords can be separated by commas. Ex.
          伊甸園，神 would return verses that contain both "伊甸園" and "神".
          <br />
          <br />
          <b>New ViewMode - Line by line</b>
          <br />
          <CustomImage src={lineByLineImg} alt="Line by Line" />
          <br />
          Added a Line by Line view mode. This mode displays each verse on a new line.
          <br />
          <br />
          <b>Internal - Migrate to Aiven DB</b>
          <br />
          Migrate the db from ElephantSQL to Aiven PostgresSQL.
          <br />
          <br />
          <b>ez-bible.com</b>
          <br />
          Added a new domain for the app. Users can now access the app using ez-bible.com.
          <br />
          <br />
        </p>

        {/* 06/15/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>06/15/2024</h3>
          <br />
          <b>Copy with Verse </b>
          <br />
          Users can now choose to copy verses with or without the verse reference.
          <br />
          Ex. "1 起初神創造天地。 2 地是空虛混沌。淵面黑暗。神的靈執行在水面上。 3 神說，要有光，就有了光。 (創世記
          1:1-3)"
          <br />
          <br />
        </p>

        {/* 05/26/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>05/26/2024</h3>
          <br />
          <b>Search History</b>
          <br />
          <CustomImage src={searchHistoryImg} alt="Search History" />
          <br />
          Users can now view their search history and click on a previous search item to re-search the same search word.
          <br />
          <br />
        </p>

        {/* 05/24/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>05/24/2024</h3>
          <br />
          <b>Forward and Backward on Chapters</b>
          <CustomImage src={forwardBackwardImg} alt="Forward and Backward on Chapters" />
          <br />
          Users now are able to navigate forward and backward on chapters. This will give the full chapter text.
          <br />
          <br />
        </p>

        {/* 05/23/2024 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>05/23/2024</h3>
          <br />
          <b>Full Chapters</b>
          <br />
          Users now are able to get the full chapter text for clicking the button on the footer.
          <br />
          <br />
        </p>

        {/* 10/31/2023 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>10/31/2023</h3>
          <br />
          <b>Text Size & Line Heights</b>
          <br />
          <CustomImage src={textSizeLineHeightImg} alt="Text Size & Line Heights" />
          <br />
          Users now are able to change the text size and line heights in the verse display area. Settings are saved in
          local storage for individual devices.
          <br />
          <br />
        </p>

        {/* 10/28/2023 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>10/28/2023</h3>
          <br />
          <b>Tips</b>
          <br />
          Added tips section to Settings Modal.
          <br />
          <br />
        </p>

        {/* 10/27/2023 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>10/27/2023</h3>
          <br />
          <b>Settings Modal</b>
          <br />
          Added a Settings Modal. Remove the old Top Bar component. Added Theme and Versions into the Settings Modal.
          <br />
          <br />
        </p>

        {/* 09/20/2023 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>09/20/2023</h3>
          <br />
          <b>Auto complete book name</b>
          <CustomImage src={autoCompleteBookNameImg} alt="Auto Complete Book Name" />
          <br />
          When users search an abbreviation of a book name, the full name will be auto-completed upon search.
          <br />
          Ex. "創 1 1 3" will be auto-completed to "創世記 1 1 3".
          <br />
          <br />
        </p>

        {/* 11/10/2022 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>11/10/2022</h3>
          <br />
          <b>Search by English book name</b>
          <CustomImage src={englishBookNameImg} alt="Search by English Book Name" />
          <br />
          Users now can search by English book name.
          <br />
          Ex. "Genesis 1 1 3" will return the same result as "創 1 1 3".
          <br />
          <br />
        </p>

        {/* 10/24/2022 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>10/24/2022</h3>
          <br />
          <b>Add error handling UI</b>
          <br />
          <br />
          <b>DropDown Menu for book name suggestion</b>
          <CustomImage src={dropDownMenuImg} alt="DropDown Menu for book name suggestion" />
          <br />
          Users now can select book names from a dropdown menu when searching for a book name.
          <br />
          <br />
        </p>

        {/* 10/23/2022 */}
        <p>
          <h3 style={{ fontSize: "20px", fontWeight: "bold" }}>10/23/2022</h3>
          <br />
          <b>Add Google Analytics</b>
          <br />
          <br />
        </p>
      </Box>
    </ModalBody>
  );
};
